<template>
    <div class="product-form-number-select">
        <div v-if = "meterQuantity > 0"  class="product-form-number-desc">
            <p>1 уп. = {{ meterQuantity }} м&sup2; = {{ boxQuantity }} шт</p>
            <p>Данный товар отпускается кратно упаковкам.</p>
        </div>
        <div class="select-number">
            <div class="select-number-body">
                <button type="button" class="select-number-btn select-number-btn-minus"
                        :class="{disabled: quantity === minimumQuantity}" @click="quantity -= quantityStep">
                    <svg width="10" height="10">
                        <use xlink:href="#icon-minus"/>
                    </svg>
                </button>
                <input type="text" class="select-number-input" :data-min="meterQuantity"
                       :value="formattedQuantity" :data-step="meterQuantity" v-on:focus="onFocusHandler"
                       v-on:change="onChangeHandler" v-on:blur="onBlurHandler"
                ><!--:data-max="meterQuantity * maximumQuantity"-->
                <button type="button" class="select-number-btn select-number-btn-plus"
                        :class="{disabled: quantity === maximumQuantity}" @click="quantity += quantityStep">
                    <svg width="10" height="10">
                        <use xlink:href="#icon-plus"/>
                    </svg>
                </button>
            </div>

            <ul v-if = "meterQuantity > 0"  class="select-number-unit-switcher">
                <li class="active">
                    <a href="#" :data-min="meterQuantity" :data-max="meterQuantity * maximumQuantity"
                       :data-value="meterQuantity * quantity" :data-step="meterQuantity" @click="mode = 'meter'">
                        м&sup2;
                    </a>
                </li>
                <li>
                    <a href="#" :data-min="minimumQuantity" :data-max="maximumQuantity" :data-value="quantity"
                       :data-step="quantityStep" data-unit=" уп."
                       @click="mode = 'box'">
                        уп.
                    </a>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
export default {
    name: "ElementPicker",
    props: {
        elementConfig: {
            type: Object,
            default: {},
        },

        meterQuantity: {
            type: Number,
            default: 0,
        },
        boxQuantity: {
            type: Number,
            default: 0,
        },
        basePrice: {
            type: Number,
            default: 0,
        },
        minimumQuantity: {
            type: Number,
            default: 1,
        },
        maximumQuantity: {
            type: Number,
            default: Infinity,
        },
        currentQuantity: {
            type: Number,
            default: 1,
        },
        quantityStep: {
            type: Number,
            default: 1,
        },
        pieceGood: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            quantity: this.currentQuantity,
            mode: 'meter', // ['meter', 'box']
        }
    },
    mounted() {
        VueEventBus.$on('element|send-add', () => this.emitBuy('element|buy'));
        VueEventBus.$on('element|send-buy', () => this.emitBuy('element|open-modal-buy'));
    },
    computed: {
        price() {
            let price ;
            if(this.meterQuantity){
                price = this.basePrice * this.quantity * this.meterQuantity;
            } else {
                price = this.basePrice * this.quantity;
            }
           
            if (this.mode === 'box') {
                price *= this.boxQuantity;
            }
            return price;
        },
        measure() {
            if(this.pieceGood) {
                return ' шт.';
            } else {
                return ' м²';
            }
        },
        formattedQuantity() {
            if (this.mode === 'meter') {
                if( this.meterQuantity === 0 ) {
                    return `${(1 * this.quantity)} ` + this.measure;
                } else {
                    return `${(this.meterQuantity * this.quantity).toFixed(2)} ` + this.measure;
                }
                
            } else {
                return `${this.quantity} уп.`;
            }
        }
    },
    watch: {
        quantity(quantity) {
            if (quantity < this.minimumQuantity || isNaN(quantity)) {
                this.quantity = this.minimumQuantity;
            }

            // if (quantity > this.maximumQuantity) {
            //     this.quantity = this.maximumQuantity;
            // }
        },
        price(price) {
            VueEventBus.$emit('element|set-price', price);
        }
    },
    methods: {
        emitBuy(event) {
            VueEventBus.$emit(event, Object.assign({}, this.elementConfig, {
                meterQuantity: this.meterQuantity,
                boxQuantity: this.boxQuantity,
                basePrice: this.basePrice,     
                minimumQuantity: this.minimumQuantity,
                maximumQuantity: this.maximumQuantity,
                currentQuantity: this.currentQuantity,
                quantityStep: this.quantityStep,
                pieceGood: this.pieceGood,
                quantity: this.quantity,
                mode: this.mode,
            }))
        },
        onFocusHandler(e) {
                e.target.value = this.quantity;
        },
        onBlurHandler(e) {
                e.target.value = this.formattedQuantity;
        },
        onChangeHandler(e) {
            this.quantity = parseInt(e.target.value);
        }
    }
}
</script>

<style scoped>

</style>